import Radio from './Radio';
import RadioGroup from './RadioGroup.js';
import RadioButton from './RadioButton';

Radio.RadioGroup = RadioGroup;
Radio.RadioButton = RadioButton;
export default Radio;
